export enum InformationPopupPage {
  BackupAndRestore = 'BackupAndRestore',
  ExtendedParameters = 'ExtendedParameters',
  GuidedTroubleshooting = 'GuidedTroubleshooting',
  HydraulicSchemes = 'HydraulicSchemes',
  Snapshot = 'Snapshot',
  RemoteServiceAnomalies = 'RemoteServiceAnomalies',
  RemoteServiceDiagnosis = 'RemoteServiceDiagnosis',
  RemoteServiceFeatures = 'RemoteServiceFeatures',
  RemoteServiceReport = 'RemoteServiceReport',
  AdvertisedBannerForShortInstructionVideo = 'AdvertisedBannerForShortInstructionVideo',
}

export interface InformationPageConfig {
  page: InformationPopupPage;
  titleKey: string;
  descriptionKey: string;
  imageUrl: string;
}
